import { createIcon } from './create-icon';

export const UsersIcon = createIcon(
  'UsersIcon',
  <>
    <circle cx="9" cy="7" r="4" />
    <path d="M2 21v-1a7 7 0 0114 0v1" />
    <path d="M16 3.13a4 4 0 010 7.75M22 21v-1a4 4 0 00-3-3.87" />
  </>,
);
